import React, { useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import "./../Styles/Designes.css";
import { useNavigate } from "react-router-dom";
import { useMenuData } from "./MenuContext";
import { API_BASE_URL, IMAGE_BASE_URL } from "./../../config/api";
const LTC_IMAGE_URL = `${IMAGE_BASE_URL}/`;
const areaOptions = [125, 250, 300, 400, 330];

export default function Category() {
  const navigate = useNavigate();
  const location = useLocation();
  const [apiPage, setApiPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const params = new URLSearchParams(location.search);

  // ✅ Get params once
  const code = params.get("code") || "";
  const cid = params.get("cid") || "";
  const subcid = params.get("subcid") || "";
  const icid = params.get("icid") || "";
  const menu = params.get("menu") || "";
  const searchCode = params.get("search") || "";
  const [widthRange, setWidthRange] = useState([0, 0]);
  const [maxWidth, setMaxWidth] = useState(0);
  // States only
  const [subMenuList, setSubMenuList] = useState([]);
  const [designs, setDesigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSubmenu, setSelectedSubmenu] = useState("");
  // const [heightRange, setHeightRange] = useState([0, 1000]);
  // Filter states
  const [search, setSearch] = useState(searchCode || code);
  const [conceptFilters, setConceptFilters] = useState([]);
  // const [priceRange, setPriceRange] = useState([0, 10000]);
  const [selectedAreas, setSelectedAreas] = useState([]);
  // const [stitchRange, setStitchRange] = useState([1000, 400000]);
  const [heightRange, setHeightRange] = useState([0, 0]);
  const [priceRange, setPriceRange] = useState([0, 0]);
  const [stitchRange, setStitchRange] = useState([0, 0]);

  const [maxHeight, setMaxHeight] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);
  const [maxStitch, setMaxStitch] = useState(0);
  const [colorFilters, setColorFilters] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [cartItems, setCartItems] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [conceptOptions, setConceptOptions] = useState([]);

  // Get user
  const getUser = () => {
    try {
      const user = localStorage.getItem("user");
      return user ? JSON.parse(user) : null;
    } catch {
      return null;
    }
  };
  const user = getUser();
  const userId = user?.id;

  // ✅ SIMPLE: Fetch submenu ONCE when cid changes
  useEffect(() => {
    if (!cid) return;

    fetch(`${API_BASE_URL}/SubCategoryList?cid=${cid}`)
      .then((res) => res.json())
      .then((result) => setSubMenuList(result.data || []))
      .catch(console.error);
  }, [cid]);
  useEffect(() => {
    // No inner category selected
    if (!icid) {
      setDesigns([]);
      setConceptOptions([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    fetch(`${API_BASE_URL}/DesignList?icid=${icid}&page=1&limit=100`)
      .then((res) => res.json())
      .then((result) => {
        const data = result.data || [];

        setDesigns(data);

        // Extract concepts
        // const concepts = [
        //   ...new Set(
        //     data
        //       .map((d) => String(d.concept || "").trim())
        //       .filter(
        //         (c) =>
        //           c !== "" &&
        //           c !== "0" &&
        //           c !== "-" &&
        //           c.toLowerCase() !== "null" &&
        //           c.toLowerCase() !== "undefined",
        //       ),
        //   ),
        // ];

        // setConceptOptions(concepts.length ? ["All", ...concepts.sort()] : []);
        // Extract unique concepts (case-insensitive)
        const maxHeightValue = Math.max(
          ...data.map((d) => Number(d.packageno) || 0),
          0,
        );

        const maxStitchValue = Math.max(
          ...data.map((d) => Number(d.stiches) || 0),
          0,
        );

        const maxPriceValue = Math.max(
          ...data.map((d) => Number(d.price) || 0),
          0,
        );

        const maxWidthValue = Math.max(
          ...data.map((d) => Number(d.sequence) || 0),
          0,
        );

        setMaxWidth(maxWidthValue);
        setWidthRange([0, maxWidthValue]);
        setMaxHeight(maxHeightValue);
        setMaxStitch(maxStitchValue);
        setMaxPrice(maxPriceValue);

        setHeightRange([0, maxHeightValue]);
        setStitchRange([0, maxStitchValue]);
        setPriceRange([0, maxPriceValue]);
        const concepts = [
          ...new Map(
            data
              .filter(
                (d) =>
                  d.concept &&
                  String(d.concept).trim() !== "" &&
                  String(d.concept).trim() !== "0" &&
                  String(d.concept).trim() !== "-" &&
                  String(d.concept).trim().toLowerCase() !== "null" &&
                  String(d.concept).trim().toLowerCase() !== "undefined",
              )
              .map((d) => {
                const original = String(d.concept).trim();
                return [original.toLowerCase(), original];
              }),
          ).values(),
        ];

        setConceptOptions(concepts.length ? ["All", ...concepts.sort()] : []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Design API error:", err);
        setDesigns([]);
        setLoading(false);
      });
  }, [icid, apiPage, itemsPerPage]);

  // ✅ Fetch user data ONCE
  useEffect(() => {
    if (!userId) return;

    Promise.all([
      fetch(`${API_BASE_URL}/Getwishlist?user_id=${userId}`).then((r) =>
        r.json(),
      ),
      fetch(`${API_BASE_URL}/Getcartlist?user_id=${userId}`).then((r) =>
        r.json(),
      ),
    ])
      .then(([wRes, cRes]) => {
        setWishlist(wRes.data || []);
        setCartItems(cRes.data || []);
      })
      .catch(console.error);
  }, [userId]);

  // Reset page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [
    search,
    selectedAreas,
    stitchRange,
    heightRange,
    colorFilters,
    conceptFilters,
    priceRange,
  ]);

  // Clear filters when URL changes
  // useEffect(() => {
  //   setSearch(searchCode || code || "");
  //   setSelectedAreas([]);
  //   setStitchRange([1000, 400000]);
  //   setColorFilters([]);
  //   setConceptFilters([]);
  //   setPriceRange([0, 10000]);
  //   setHeightRange([0, 1000]);
  //   setCurrentPage(1);
  // }, [cid]);

  useEffect(() => {
    setSearch(searchCode || code || "");
    setSelectedAreas([]);
    setColorFilters([]);
    setConceptFilters([]);
    setCurrentPage(1);
    setWidthRange([0, maxWidth]);
    setStitchRange([0, maxStitch]);
    setHeightRange([0, maxHeight]);
    setPriceRange([0, maxPrice]);
  }, [cid, maxStitch, maxHeight, maxPrice, maxWidth]);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const handleSubmenuSelect = (subId) => {
    const selectedSub = menuData
      .find((c) => c.id.toString() === cid)
      ?.columns.find((s) => s.id.toString() === subId.toString());

    const firstInnerId = selectedSub?.links?.[0]?.id || "";

    navigate(
      `/category?cid=${cid}&subcid=${subId}&icid=${firstInnerId}&menu=${encodeURIComponent(menu)}`,
    );
  };
  const getImageUrl = (item) =>
    item.image_url
      ? `${LTC_IMAGE_URL}${item.image_url}`
      : "/images/no-image.png";

  const toggleArea = (area) => {
    setSelectedAreas((prev) =>
      prev.includes(area) ? prev.filter((a) => a !== area) : [...prev, area],
    );
    setCurrentPage(1);
  };

  const toggleColor = (color) => {
    setColorFilters((prev) =>
      prev.includes(color) ? prev.filter((c) => c !== color) : [...prev, color],
    );
    setCurrentPage(1);
  };

  const toggleConcept = (concept) => {
    if (concept === "All") setConceptFilters([]);
    else
      setConceptFilters((prev) =>
        prev.includes(concept)
          ? prev.filter((c) => c !== concept)
          : [...prev, concept],
      );
    setCurrentPage(1);
  };

  const fetchWishlist = async () => {
    if (!userId) return;
    try {
      const res = await fetch(`${API_BASE_URL}/Getwishlist?user_id=${userId}`);
      setWishlist((await res.json()).data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchCart = async () => {
    if (!userId) return;
    try {
      const res = await fetch(`${API_BASE_URL}/Getcartlist?user_id=${userId}`);
      setCartItems((await res.json()).data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const toggleWishlist = async (design) => {
    if (!userId) return alert("Please login");
    const designId = design.design_id || design.id;
    const isIn = wishlist.some(
      (w) => Number(w.design_id ?? w.id) === Number(designId),
    );

    try {
      const url = isIn
        ? `${API_BASE_URL}/RemoveWishlistDesign?cart_id=${wishlist.find((w) => Number(w.design_id ?? w.id) === Number(designId))?.cart_id}&user_id=${userId}`
        : `${API_BASE_URL}/InsertWishlist?user_id=${userId}&design_id=${designId}`;

      await fetch(url, { method: "GET" });
      fetchWishlist();
      window.dispatchEvent(new Event("wishlistUpdated"));
    } catch (err) {
      console.error(err);
    }
  };

  const addToCart = async (design) => {
    if (!userId) return alert("Please login first");
    const designId = design.design_id || design.id;
    const existing = cartItems.find(
      (c) => Number(c.design_id ?? c.id) === Number(designId),
    );

    try {
      const url = existing
        ? `${API_BASE_URL}/RemoveCartDesign?cart_id=${existing.cartId}&user_id=${userId}`
        : `${API_BASE_URL}/InsertCartlist?user_id=${userId}&design_id=${designId}`;

      await fetch(url, { method: "GET" });
      fetchCart();
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error(err);
    }
  };

  const isInWishlist = (design) =>
    wishlist.some(
      (w) =>
        Number(w.design_id ?? w.id) === Number(design.design_id ?? design.id),
    );
  const isInCart = (design) =>
    cartItems.some(
      (c) =>
        Number(c.design_id ?? c.id) === Number(design.design_id ?? design.id),
    );

  // Filter designs
  const filteredDesigns = designs.filter((item) => {
    const searchMatch =
      item.code?.toLowerCase().includes(search.toLowerCase()) ||
      item.id?.toString().includes(search);
    const areaMatch =
      selectedAreas.length === 0 || selectedAreas.includes(parseInt(item.area));
    const stitchMatch =
      (parseInt(item.stiches) || 0) >= stitchRange[0] &&
      (parseInt(item.stiches) || 0) <= stitchRange[1];
    const colorMatch =
      colorFilters.length === 0 ||
      colorFilters.includes(item.color?.toString());
    const height = parseFloat(item.packageno) || 0;

    const heightMatch =
      height >= heightRange[0] &&
      (heightRange[1] === 0 || height <= heightRange[1]);

    const width = parseFloat(item.sequence) || 0;

    const widthMatch =
      width >= widthRange[0] && (widthRange[1] === 0 || width <= widthRange[1]);
    // const conceptMatch =
    //   conceptFilters.length === 0 ||
    //   conceptFilters.some(
    //     (c) => String(item.concept || "").toLowerCase() === c.toLowerCase(),
    //   );

    // const conceptValue = String(item.concept || "").trim();
    const conceptValue = String(item.concept || "")
      .trim()
      .toLowerCase();

    const conceptMatch =
      conceptFilters.length === 0 ||
      conceptFilters.some((c) => conceptValue === c.trim().toLowerCase());
    // const conceptMatch =
    //   conceptFilters.length === 0 ||
    //   conceptFilters.some(
    //     (c) => conceptValue.toLowerCase() === c.toLowerCase(),
    //   );
    const priceMatch =
      (parseFloat(item.price) || 0) >= priceRange[0] &&
      (parseFloat(item.price) || 0) <= priceRange[1];
    return (
      searchMatch &&
      areaMatch &&
      stitchMatch &&
      colorMatch &&
      conceptMatch &&
      priceMatch &&
      heightMatch &&
      widthMatch
    );
  });

  const currentDesigns = filteredDesigns.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );
  const totalPages = Math.ceil(filteredDesigns.length / itemsPerPage);

  const { menuData } = useMenuData();
  const innerCategoryList = useMemo(() => {
    if (!cid || !subcid || !menuData.length) return [];
    const cat = menuData.find((c) => c.id.toString() === cid);
    return (
      cat?.columns?.find((col) => col.id.toString() === subcid)?.links || []
    );
  }, [cid, subcid, menuData]);
  const getFirstSubAndInner = (cid) => {
    const category = menuData.find((c) => c.id.toString() === cid);

    if (!category || !category.columns.length) {
      return { subcid: "", icid: "" };
    }

    const firstSub = category.columns[0];

    return {
      subcid: firstSub.id,
      icid: firstSub.links?.[0]?.id || "",
    };
  };
  const firstData = cid ? getFirstSubAndInner(cid) : {};

  const breadcrumbItems = [
    {
      label: (
        <>
          <i className="bi bi-house"></i> Home
        </>
      ),
      link: "/",
    },

    cid &&
      menu && {
        label: menu,
        link: `/category?cid=${cid}&subcid=${firstData.subcid}&icid=${firstData.icid}&menu=${encodeURIComponent(menu)}`,
      },

    subcid && {
      label:
        subMenuList.find((s) => s.id.toString() === subcid)
          ?.subcategorynameweb || "Sub Category",

      // Redirect to first inner category of selected subcategory
      link: `/category?cid=${cid}&subcid=${subcid}&icid=${
        innerCategoryList[0]?.id || ""
      }&menu=${encodeURIComponent(menu)}`,
    },

    icid && {
      label: designs[0]?.innercategory || "Designs",
      link: "#",
    },
  ].filter(Boolean);

  // Render
  if (loading) {
    return (
      // <div className="designs-grid">
      //   {[...Array(12)].map((_, i) => (
      //     <div className="design-card skeleton-card" key={i}>
      //       <div className="skeleton-img shimmer"></div>
      //       <div className="card-body">
      //         <div className="skeleton-text shimmer w-75"></div>
      //         <div className="skeleton-text shimmer w-50"></div>
      //         <div className="skeleton-price shimmer"></div>
      //         <div className="skeleton-btn shimmer"></div>
      //       </div>
      //     </div>
      //   ))}
      // </div>

      <div className="page-loader">
        <div style={styles.loadingContainer}>
          <div className="spinner-border text-primary mb-3"></div>
          <h5>Loading Your Design...</h5>

          <p>Please wait while we prepare everything for you.</p>
        </div>
      </div>
      // <div className="page-loader">
      //   <div className="loader-spinner"></div>
      //   <h2>⏳ Please Wait...</h2>
      //   <p>We're loading your design details. This will only take a moment.</p>
      // </div>
    );
  }
  const getPaginationItems = () => {
    const pages = [];
    const blockSize = 10;

    const startPage = Math.floor((currentPage - 1) / blockSize) * blockSize + 1;

    const endPage = Math.min(startPage + blockSize - 1, totalPages);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };
  return (
    <div className="designs-page container-fluid py-3">
      <div className="container-fluid">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            {breadcrumbItems.map((item, i) => (
              <li
                key={i}
                className={`breadcrumb-item ${i === breadcrumbItems.length - 1 ? "active" : ""}`}
              >
                {i === breadcrumbItems.length - 1 ? (
                  item.label
                ) : (
                  <a href={item.link}>{item.label}</a>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>

      <div className="row g-4 mx-2 cat">
        {/* SIDEBAR */}
        <div className="col-lg-2 side">
          <div
            className="modern-filter-sidebar shadow-lg rounded-4 position-sticky"
            style={{ top: "60px" }}
          >
            <div className="sidebar-header border-bottom">
              <h5 className="section-title mb-0 fw-bold text-white">
                {menu || "Filters"}
              </h5>
            </div>

            {/* Submenu */}
            {cid && subMenuList.length > 0 && (
              <div className="filter-section">
                <div
                  className="filter-header d-flex justify-content-between align-items-center p-3 cursor-pointer"
                  onClick={() =>
                    setSelectedSubmenu(
                      selectedSubmenu === "submenus" ? "" : "submenus",
                    )
                  }
                  style={{ borderBottom: "1px solid #eee" }}
                >
                  <span className="filter-label fw-semibold text-dark">
                    <i className="bi bi-list-ul me-2"></i>Sub Categories
                  </span>
                  <i
                    className={`bi ${selectedSubmenu === "submenus" ? "bi-chevron-up" : "bi-chevron-down"} fs-5`}
                  ></i>
                </div>
                {selectedSubmenu === "submenus" && (
                  <div
                    className="submenu-list p-2"
                    style={{ maxHeight: "300px", overflowY: "auto" }}
                  >
                    {subMenuList.map((sub, i) => (
                      <div
                        key={i}
                        className={`submenu-item p-2 mb-1 rounded-2 cursor-pointer ${subcid === sub.id.toString() ? "bg-primary text-white fw-semibold" : "bg-light"}`}
                        onClick={() => handleSubmenuSelect(sub.id)}
                      >
                        {sub.subcategorynameweb || sub.subcategoryname}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* Area */}

            {conceptOptions.length > 1 && (
              <div className="filter-section">
                <div
                  className="filter-header d-flex justify-content-between align-items-center p-3 cursor-pointer"
                  onClick={() =>
                    setSelectedSubmenu(
                      selectedSubmenu === "concepts" ? "" : "concepts",
                    )
                  }
                >
                  <span className="filter-label fw-semibold text-dark">
                    <i className="bi bi-lightbulb me-2"></i>Concepts
                  </span>
                  <i
                    className={`bi ${selectedSubmenu === "concepts" ? "bi-chevron-up" : "bi-chevron-down"} fs-5`}
                  ></i>
                </div>
                {selectedSubmenu === "concepts" && (
                  <div
                    className="p-2"
                    style={{ maxHeight: "250px", overflowY: "auto" }}
                  >
                    {conceptOptions.map((concept) => (
                      <div key={concept} className="form-check mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`concept-${concept}`}
                          checked={
                            concept === "All"
                              ? conceptFilters.length === 0
                              : conceptFilters.includes(concept)
                          }
                          onChange={() => toggleConcept(concept)}
                        />
                        <label
                          className="form-check-label fw-semibold"
                          htmlFor={`concept-${concept}`}
                        >
                          {concept}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            <div className="filter-section">
              <div
                className="filter-header d-flex justify-content-between align-items-center p-3 cursor-pointer"
                onClick={() =>
                  setSelectedSubmenu(selectedSubmenu === "areas" ? "" : "areas")
                }
                style={{ borderBottom: "1px solid #eee" }}
              >
                <span className="filter-label fw-semibold text-dark">
                  <i className="bi bi-grid-3x3-gap me-2"></i>Area
                </span>
                <i
                  className={`bi ${selectedSubmenu === "areas" ? "bi-chevron-up" : "bi-chevron-down"} fs-5`}
                ></i>
              </div>
              {selectedSubmenu === "areas" && (
                <div className="p-2">
                  <div className="row g-2">
                    {areaOptions.map((area) => (
                      <div key={area} className="col-4">
                        <input
                          className="form-check-input m-2"
                          type="checkbox"
                          id={`area-${area}`}
                          checked={selectedAreas.includes(area)}
                          onChange={() => toggleArea(area)}
                        />
                        <label
                          className="form-check-label fw-semibold"
                          htmlFor={`area-${area}`}
                        >
                          {area}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {/* Height */}

            {/* <div className="filter-section">
              <div
                className="filter-header d-flex justify-content-between align-items-center p-3 cursor-pointer"
                onClick={() =>
                  setSelectedSubmenu(selectedSubmenu === "width" ? "" : "width")
                }
              >
                <span className="filter-label fw-semibold text-dark">
                  <i className="bi bi-arrows-horizontal me-2"></i>Width
                </span>

                <i
                  className={`bi ${
                    selectedSubmenu === "width"
                      ? "bi-chevron-up"
                      : "bi-chevron-down"
                  } fs-5`}
                ></i>
              </div>

              {selectedSubmenu === "width" && (
                <div className="p-3">
                  <div className="row g-2">
                    <div className="col-6">
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Min"
                        value={widthRange[0] === 0 ? "" : widthRange[0]}
                        onChange={(e) =>
                          setWidthRange([
                            e.target.value === "" ? 0 : Number(e.target.value),
                            widthRange[1],
                          ])
                        }
                      />
                    </div>

                    <div className="col-6">
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Max"
                        value={widthRange[1] === 0 ? "" : widthRange[1]}
                        onChange={(e) =>
                          setWidthRange([
                            widthRange[0],
                            e.target.value === "" ? 0 : Number(e.target.value),
                          ])
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
            </div> */}
            {/* Stitch */}
            <div className="filter-section">
              <div
                className="filter-header d-flex justify-content-between align-items-center p-3 cursor-pointer"
                onClick={() =>
                  setSelectedSubmenu(
                    selectedSubmenu === "stitch" ? "" : "stitch",
                  )
                }
              >
                <span className="filter-label fw-semibold text-dark">
                  <i className="bi bi-scissors me-2"></i>Stitch
                </span>
                <i
                  className={`bi ${selectedSubmenu === "stitch" ? "bi-chevron-up" : "bi-chevron-down"} fs-5`}
                ></i>
              </div>{" "}
              {selectedSubmenu === "stitch" && (
                <div className="p-3">
                  <div className="row g-2">
                    <div className="col-6">
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Min"
                        value={stitchRange[0] === 0 ? "" : stitchRange[0]}
                        onChange={(e) =>
                          setStitchRange([
                            e.target.value === "" ? 0 : Number(e.target.value),
                            stitchRange[1],
                          ])
                        }
                      />
                    </div>
                    <div className="col-6">
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Max"
                        value={stitchRange[1] === 0 ? "" : stitchRange[1]}
                        onChange={(e) =>
                          setStitchRange([
                            stitchRange[0],
                            e.target.value === "" ? 0 : Number(e.target.value),
                          ])
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Colors */}
            <div className="filter-section">
              <div
                className="filter-header d-flex justify-content-between align-items-center p-3 cursor-pointer"
                onClick={() =>
                  setSelectedSubmenu(
                    selectedSubmenu === "colors" ? "" : "colors",
                  )
                }
              >
                <span className="filter-label fw-semibold text-dark">
                  <i className="bi bi-palette me-2"></i>Colours
                </span>
                <i
                  className={`bi ${selectedSubmenu === "colors" ? "bi-chevron-up" : "bi-chevron-down"} fs-5`}
                ></i>
              </div>
              {selectedSubmenu === "colors" && (
                <div className="p-2">
                  <div className="row g-2">
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((c) => (
                      // <div key={c} className="col-4">
                      //   <input
                      //     className="form-check-input m-2"
                      //     type="checkbox"
                      //     id={`color-${c}`}
                      //     checked={colorFilters.includes(c.toString())}
                      //     onChange={() => toggleColor(c.toString())}
                      //   />
                      //   <label
                      //     className="form-check-label fw-semibold"
                      //     htmlFor={`color-${c}`}
                      //   >
                      //     {c}
                      //   </label>
                      // </div>
                      <div key={c} className="col-4">
                        <div className="color-option">
                          <input
                            className="form-check-input color-checkbox"
                            type="checkbox"
                            id={`color-${c}`}
                            checked={colorFilters.includes(c.toString())}
                            onChange={() => toggleColor(c.toString())}
                          />
                          <label className="color-label" htmlFor={`color-${c}`}>
                            {c}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Concept */}

            <div className="filter-section">
              <div
                className="filter-header d-flex justify-content-between align-items-center p-3 cursor-pointer"
                onClick={() =>
                  setSelectedSubmenu(
                    selectedSubmenu === "height" ? "" : "height",
                  )
                }
              >
                <span className="filter-label fw-semibold text-dark">
                  <i className="bi bi-arrows-vertical me-2"></i>Height
                </span>

                <i
                  className={`bi ${
                    selectedSubmenu === "height"
                      ? "bi-chevron-up"
                      : "bi-chevron-down"
                  } fs-5`}
                ></i>
              </div>

              {selectedSubmenu === "height" && (
                <div className="p-3">
                  <div className="row g-2">
                    <div className="col-6">
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Min"
                        value={heightRange[0] === 0 ? "" : heightRange[0]}
                        onChange={(e) =>
                          setHeightRange([
                            e.target.value === "" ? 0 : Number(e.target.value),
                            heightRange[1],
                          ])
                        }
                      />
                    </div>

                    <div className="col-6">
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Max"
                        value={heightRange[1] === 0 ? "" : heightRange[1]}
                        onChange={(e) =>
                          setHeightRange([
                            heightRange[0],
                            e.target.value === "" ? 0 : Number(e.target.value),
                          ])
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Price */}
            <div className="filter-section">
              <div
                className="filter-header d-flex justify-content-between align-items-center p-3 cursor-pointer"
                onClick={() =>
                  setSelectedSubmenu(selectedSubmenu === "price" ? "" : "price")
                }
              >
                <span className="filter-label fw-semibold text-dark">
                  <i className="bi bi-currency-rupee me-2"></i>Price
                </span>
                <i
                  className={`bi ${selectedSubmenu === "price" ? "bi-chevron-up" : "bi-chevron-down"} fs-5`}
                ></i>
              </div>
              {selectedSubmenu === "price" && (
                <div className="p-3">
                  <div className="row g-2">
                    <div className="col-6">
                      <small className="text-muted">Min</small>
                      <input
                        type="number"
                        className="form-control form-control-sm mt-1 text-center fw-bold"
                        value={priceRange[0] === 0 ? "" : priceRange[0]}
                        onChange={(e) =>
                          setPriceRange([
                            e.target.value === "" ? 0 : Number(e.target.value),
                            priceRange[1],
                          ])
                        }
                      />
                    </div>
                    <div className="col-6">
                      <small className="text-muted">Max</small>
                      <input
                        type="number"
                        className="form-control form-control-sm mt-1 text-center fw-bold"
                        value={priceRange[1] === 0 ? "" : priceRange[1]}
                        onChange={(e) =>
                          setPriceRange([
                            priceRange[0],
                            e.target.value === "" ? 0 : Number(e.target.value),
                          ])
                        }
                      />
                    </div>
                  </div>
                  <div className="mt-2 text-center">
                    <small className="text-muted">
                      <span className="rupee-symbol">₹</span> {priceRange[0]} -
                      <span className="rupee-symbol">₹</span> {priceRange[1]}
                    </small>
                  </div>
                </div>
              )}
            </div>

            {/* Clear */}
            <div className="p-3 pt-0">
              <button
                className="btn btn-outline-danger w-100"
                onClick={() => {
                  // setSearch("");
                  // setSelectedAreas([]);
                  // setStitchRange([1000, 400000]);
                  // setColorFilters([]);
                  // setConceptFilters([]);
                  // setPriceRange([0, 10000]);
                  // setCurrentPage(1);
                  // setHeightRange([0, 1000]);
                  setSearch("");
                  setSelectedAreas([]);
                  setColorFilters([]);
                  setConceptFilters([]);
                  setCurrentPage(1);

                  setStitchRange([0, maxStitch]);
                  setHeightRange([0, maxHeight]);
                  setPriceRange([0, maxPrice]);
                }}
              >
                <i className="bi bi-arrow-clockwise me-1"></i>Clear All
              </button>
            </div>
          </div>
        </div>

        {/* DESIGNS GRID */}
        <div className="col-lg-10 col-md-12">
          <div className="horizontal-categories-wrapper mb-3">
            <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
              <h2 className="section-title m-0">
                {subcid
                  ? subMenuList.find((s) => s.id.toString() === subcid)
                      ?.subcategorynameweb ||
                    innerCategoryList[0]?.heading ||
                    "Designs"
                  : menu || "Designs"}
              </h2>
              <select
                className="form-select form-select-sm"
                style={{ width: "70px" }}
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(parseInt(e.target.value));
                  setCurrentPage(1);
                }}
              >
                <option value={20}>20</option>
                <option value={40}>40</option>
                <option value={60}>60</option>
                <option value={80}>80</option>
                <option value={100}>100</option>
              </select>
            </div>

            {/* Inner Tabs */}
            {innerCategoryList.length > 0 && (
              <div className="inner-category-tabs">
                {/* <div
                  className={`inner-tab-btn ${!icid ? "active-tab" : ""}`}
                  onClick={() =>
                    navigate(
                      `/category?cid=${cid}&subcid=${subcid}&menu=${encodeURIComponent(menu)}`,
                    )
                  }
                >
                  All
                </div> */}
                {/* Horizontal Sub Categories */}
                {/* {subMenuList.length > 0 && (
                  <div className="subcategory-tabs mb-3">
                    {subMenuList.map((sub) => (
                      <button
                        key={sub.id}
                        className={`subcategory-tab ${
                          subcid === sub.id.toString() ? "active" : ""
                        }`}
                        onClick={() => handleSubmenuSelect(sub.id)}
                      >
                        {sub.subcategorynameweb || sub.subcategoryname}
                      </button>
                    ))}
                  </div>
                )} */}
                <div className="inner-category-tabs">
                  {innerCategoryList.map((innerCat) => (
                    <button
                      key={innerCat.id}
                      className={`inner-tab-btn ${
                        icid === innerCat.id.toString() ? "active-tab" : ""
                      }`}
                      onClick={() =>
                        navigate(
                          `/category?cid=${cid}&subcid=${subcid}&icid=${innerCat.id}&menu=${encodeURIComponent(menu)}`,
                        )
                      }
                    >
                      {innerCat.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Designs Grid */}
            {!loading && currentDesigns.length === 0 ? (
              <div className="empty-state text-center py-5">
                <div className="empty-icon mb-3">
                  <i className="bi bi-search"></i>
                </div>
                <h4 className="mb-2">No designs found</h4>
                <p className="text-muted mb-0">
                  Try adjusting your filters or search criteria
                </p>
                <button
                  className="btn btn-primary btn-sm mt-3"
                  onClick={() => {
                    // setSearch("");
                    // setSelectedAreas([]);
                    // setStitchRange([1000, 400000]);
                    // setColorFilters([]);
                    // setConceptFilters([]);
                    // setPriceRange([0, 10000]);
                    // setCurrentPage(1);
                    setSearch("");
                    setSelectedAreas([]);
                    setColorFilters([]);
                    setConceptFilters([]);
                    setCurrentPage(1);

                    setStitchRange([0, maxStitch]);
                    setHeightRange([0, maxHeight]);
                    setPriceRange([0, maxPrice]);
                  }}
                >
                  <i className="bi bi-arrow-clockwise me-1"></i> Clear Filters
                </button>
              </div>
            ) : (
              <>
                <div className="designs-grid">
                  {currentDesigns.map((item, index) => (
                    <div
                      className="design-card"
                      key={`${item.id}-${item.code}-${index}`}
                      onClick={() =>
                        window.open(
                          `/product?code=${item.code}&cid=${cid}&subcid=${subcid}&icid=${item.icid || icid}&menu=${encodeURIComponent(menu)}`,
                          "_blank",
                        )
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <div className="uniq-image-wrapper">
                        <img
                          src={getImageUrl(item)}
                          alt={item.code}
                          className="uniq-design-image"
                        />
                      </div>
                      <div className="card-body">
                        <div className="design-specs">
                          <div className="spec-left text-start">
                            <div>
                              <strong>Code:</strong> {item.code}
                            </div>
                            <div>
                              <strong>Stitch:</strong> {item.stiches}
                            </div>
                            <div>
                              <strong>Height:</strong> {item.packageno}
                            </div>
                            <div>
                              <strong>Concept:</strong> {item.concept}
                            </div>
                          </div>
                          <div className="spec-right text-end">
                            <div>
                              <strong>Area:</strong> {item.area}
                            </div>
                            <div>
                              <strong>Colour:</strong> {item.color}
                            </div>
                            <div>
                              <strong>Width:</strong> {item.sequence}
                            </div>
                          </div>
                        </div>
                        <h5 className="price-tag-row text-center mt-2">
                          <span className="rupee-symbol">₹</span> {item.price}
                        </h5>
                        <div className="card-action-row">
                          <div className="action-btns">
                            <button
                              className={`select-btn ${isInCart(item) ? "in-cart" : ""}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                addToCart(item);
                              }}
                            >
                              {isInCart(item) ? (
                                <>
                                  <i className="bi bi-cart-check-fill me-1"></i>
                                  SELECTED
                                </>
                              ) : (
                                <>
                                  <i className="bi bi-cart me-1"></i>SELECT
                                  DESIGN
                                </>
                              )}
                            </button>
                            <button
                              className={`wish-btn ${isInWishlist(item) ? "active" : ""}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleWishlist(item);
                              }}
                            >
                              <i
                                className={`bi ${isInWishlist(item) ? "bi-heart-fill" : "bi-heart"}`}
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {totalPages > 1 && (
                  <div className="pagination-container d-flex justify-content-center mt-5">
                    <ul className="pagination custom-pagination">
                      {/* Previous Block */}
                      <li
                        className={`page-item ${
                          currentPage <= 10 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => {
                            const startPage =
                              Math.floor((currentPage - 1) / 10) * 10 + 1;

                            if (startPage > 1) {
                              setCurrentPage(startPage - 10);
                              scrollToTop();
                            }
                          }}
                        >
                          Prev
                        </button>
                      </li>

                      {/* Current Block Pages */}
                      {getPaginationItems().map((page) => (
                        <li
                          key={page}
                          className={`page-item ${
                            page === currentPage ? "active" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => {
                              setCurrentPage(page);
                              scrollToTop();
                            }}
                          >
                            {page}
                          </button>
                        </li>
                      ))}

                      {/* Last Page */}
                      {totalPages > 10 &&
                        !getPaginationItems().includes(totalPages) && (
                          <>
                            {/* <li className="page-item disabled">
                              <span className="page-link">...</span>
                            </li> */}

                            <li
                              className={`page-item ${
                                currentPage === totalPages ? "active" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => {
                                  setCurrentPage(totalPages);
                                  scrollToTop();
                                }}
                              >
                                {totalPages}
                              </button>
                            </li>
                          </>
                        )}

                      {/* Next Block */}
                      <li
                        className={`page-item ${
                          Math.floor((currentPage - 1) / 10) * 10 + 11 >
                          totalPages
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => {
                            const startPage =
                              Math.floor((currentPage - 1) / 10) * 10 + 1;

                            const nextBlockStart = startPage + 10;

                            if (nextBlockStart <= totalPages) {
                              setCurrentPage(nextBlockStart);
                              scrollToTop();
                            }
                          }}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
const styles = {
  loadingContainer: {
    minHeight: "50vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
};
